import React, { memo } from 'react';
export function WhatIsIncluded() {
  const resources = [{
    title: 'Metodo Lezioni Musicali Coinvolgenti',
    desc: 'Una guida pratica per strutturare lezioni di musica chiare, dinamiche e molto più efficaci.',
    colorClass: 'bg-blue-50 border-blue-200 text-blue-900',
    numColor: 'text-blue-600'
  }, {
    title: 'Psicologia della Motivazione Musicale',
    desc: "Strategie semplici per mantenere alta l'attenzione degli studenti e aumentare il loro desiderio di imparare.",
    colorClass: 'bg-green-50 border-green-200 text-green-900',
    numColor: 'text-green-600'
  }, {
    title: 'Sistema di Progresso per Studenti di Musica',
    desc: 'Un metodo concreto per monitorare miglioramenti, risultati e piccoli successi lezione dopo lezione.',
    colorClass: 'bg-orange-50 border-orange-200 text-orange-900',
    numColor: 'text-orange-600'
  }, {
    title: 'Attività e Dinamiche per Insegnanti di Musica',
    desc: 'Esercizi, giochi e attività per rendere ogni lezione più viva, pratica e memorabile.',
    colorClass: 'bg-purple-50 border-purple-200 text-purple-900',
    numColor: 'text-purple-600'
  }, {
    title: 'Il Metodo del Professore di Musica Moderno',
    desc: 'La risorsa completa per insegnare con più sicurezza, più metodo e più impatto educativo.',
    colorClass: 'bg-red-50 border-red-200 text-red-900',
    numColor: 'text-red-600'
  }];
  return <section className="py-16 md:py-24 px-4 bg-gray-50" data-id="element-313">
      <div className="max-w-4xl mx-auto" data-id="element-314">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-315">
          Cosa troverai all'interno del MegaPack
        </h2>

        <div className="space-y-6" data-id="element-316">
          {resources.map((res, index) => <div key={index} className={`rounded-2xl border p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center gap-6 shadow-sm hover:shadow-md transition-shadow ${res.colorClass}`} data-id="element-317">
              <div className="w-14 h-14 rounded-full bg-white/60 flex items-center justify-center flex-shrink-0 shadow-sm" data-id="element-318">
                <span className={`text-2xl font-bold ${res.numColor}`} data-id="element-319">
                  {index + 1}
                </span>
              </div>
              <div data-id="element-320">
                <h3 className="text-xl md:text-2xl font-bold mb-2" data-id="element-321">
                  {res.title}
                </h3>
                <p className="text-lg opacity-90" data-id="element-322">{res.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}